import React from "react";

import "./InwerkProductAward.scss";

const InwerkProductAward = ({productAward, index}) => {
    // only display 3 badges
    if (index > 2) {
        return;
    }

    return (
        <div className="product-award-algolia" >
            <img src={productAward.imageUrl} alt={productAward.imageAltText}/>
        </div>
    );
};

export default InwerkProductAward;
